import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no_send",
  "use": "icon-no_send-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-no_send\">\n    <circle cx=\"8\" cy=\"8\" r=\"7\" fill=\"#D9D9D9\" />\n    <path d=\"M4.5 8L11.5 8\" stroke=\"white\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol